module.exports = __webpack_public_path__ + "static/img/icon_exclamation@.7a830d7.png";